import { HistoricoListSearchComponent } from './HistoricoListSearchComponent'

export const HistoricoListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <HistoricoListSearchComponent />
    </div>
  )
}
